<template>
    <div class="p-2 mt-4">
        <section class="flex justify-end md:flex-col">
            
            <div class="flex md:flex-col md:mt-2 mr-4">
                <div >
                   <div>
                        <label class="text-blue-600" for="start Date">Choose start Date</label>
                        <input class="border pl-2 pr-2 ml-2" type="date" placeholder="Start Date" v-model="startDate">
                   </div>
                   <div class="mt-1">
                        <label class="text-blue-600" for="start Date">Choose end Date</label>
                        <input class="border pl-2 pr-2 ml-3" type="date" placeholder="End Date" v-model="endDate">
                   </div>
                   <div class="text-right text-sm mt-1">
                     <button class="text-white bg-blue-500 w-10 rounded-sm" @click="dateSearch">GO</button>
                   </div>
                </div>
                <div class="ml-3 md:ml-0 md:mt-2">
                    <input class="border-2 p-1 rounded-lg w-full" type="text" name="search" id="search" placeholder="search" v-model="searchQuery">
                    <span class="-ml-6">
                        <i class="fa fa-search"></i>
                    </span>
                </div>
            </div>
        </section>

        <section v-show="transactionLists" class="mt-6 md:overflow-x-auto">
            <table class="table-auto w-full">
                <thead>
                    <tr class="border-b-2">
                        <td>Source</td>
                        <!-- <td class=" w-25">Receiver</td> -->
                        <td>Amount</td>
                        <td>Status</td>
                        <td>Description</td>
                        <td>Trans Date</td>
                        <td>Trans Time</td>
                    </tr>
                </thead>

                <tbody>
                    <tr class="border border-b" v-for="trans in filterName" :key="trans.id">
                        <!-- <td class="w-40 p-2">{{trans.transferCode}}</td> -->
                        <td class=" text-blue-600">{{trans.source}}</td>
                        <!-- <td>User</td> -->
                        <!-- <td class="">Refund</td> -->
                        <td>NGN {{trans.amount.toLocaleString()}}</td>
                        <td class=" text-blue-600">{{trans.status}}</td>
                        <td class=" text-blue-600">{{trans.description}}</td>
                        <td >{{moment(trans.dateCreated).format("DD/MM/YY")}}</td>
                        <td>{{moment(trans.dateCreated).format("LT")}}</td>
                        <td class="relative">
                        <span>
                            <i @click="toggleList(trans)" class="fa fa-ellipsis-v cursor-pointer relative"></i>
                            <div v-show="trans.showItem" class="text-xs z-20 absolute bg-white shadow-2xl border w-32 right-5 text-center p-1">
                                <router-link :to="{name: 'transaction-info', params: {id: trans.txRef}}">View Transaction</router-link>
                            </div>
                        </span>
                        </td>
                    </tr>
                </tbody>
            </table>
            {{error}}

            <section>
                <div v-if="!searchQuery" class="flex justify-between mt-10 text-gray-500">
                    <div>
                        <p>Showing {{currentPage}}of {{totalPages}} Pages of {{currentList}} Transactions </p>
                    </div>

                    <div class="flex">
                        <button @click="prev" class="border w-24 text-center text-blue-600  border-blue-600"> <i class="fa fa-angle-left mr-2"></i>Previous </button>
                        <button @click="next" class="border w-24 text-center border-blue-600 text-blue-600 ml-1">Next <i class="fa fa-angle-right ml-2"></i></button>
                    </div>
                </div>
            </section>
            <div class="mt-4 ">
                <button @click="print" class="border w-24 text-center rounded-lg bg-blue-600  text-white">Print</button>
            </div>
        </section>

        <section v-show="dateTransaction" class="mt-6 md:overflow-x-auto">
            <table class="table-auto w-full">
                <thead>
                    <tr class="border-b-2">
                        <td>Source</td>
                        <!-- <td class=" w-25">Receiver</td> -->
                        <td>Amount</td>
                        <td>Status</td>
                        <td>Description</td>
                        <td>Trans Date</td>
                        <td>Trans Time</td>
                    </tr>
                </thead>

                <tbody>
                    {{empty}}
                    <tr class="border border-b" v-for="trans in filterNameSearch" :key="trans.id">
                        <!-- <td class="w-40 p-2">{{trans.transferCode}}</td> -->
                        <td class=" text-blue-600">{{trans.source}}</td>
                        <!-- <td>User</td> -->
                        <!-- <td class="">Refund</td> -->
                        <td>NGN {{trans.amount.toLocaleString()}}</td>
                        <td class=" text-blue-600">{{trans.status}}</td>
                        <td class=" text-blue-600">{{trans.description}}</td>
                        <td >{{moment(trans.dateCreated).format("DD/MM/YY")}}</td>
                        <td>{{moment(trans.dateCreated).format("LT")}}</td>
                        <td class="relative">
                        <span>
                            <i @click="toggleList(trans)" class="fa fa-ellipsis-v cursor-pointer relative"></i>
                            <div v-show="trans.showItem" class="text-xs z-20 absolute bg-white shadow-2xl border w-32 right-5 text-center p-1">
                                <router-link :to="{name: 'transaction-info', params: {id: trans.txRef} }">View Transaction</router-link>
                            </div>
                        </span>
                        </td>
                    </tr>
                </tbody>
            </table>
            {{error}}

             <section>
                <div v-if="!searchQuery" class="flex justify-between mt-10 text-gray-500">
                    <div>
                        <p>Showing {{currentDateList}} Search Results </p>
                    </div>

                    <div class="flex">
                        <button @click="prevSearch" class="border w-24 text-center text-blue-600  border-blue-600"> <i class="fa fa-angle-left mr-2"></i>Previous </button>
                        <button @click="nextSearch" class="border w-24 text-center border-blue-600 text-blue-600 ml-1">Next <i class="fa fa-angle-right ml-2"></i></button>
                    </div>
                </div>
            </section>
            <div class="mt-4 ">
                <button @click="print" class="border w-24 text-center rounded-lg bg-blue-600  text-white">Print</button>
            </div>
        </section>

        
    </div>
</template>

<script>
import axios from 'axios';
import {baseUrl} from '../../../../Config';
const url = baseUrl;
import moment from 'moment';
export default {
    data() {
        return {
            searchQuery: "",
            showItem : null,
            userId: localStorage.getItem("userId"),
            transactions: [],
            dateTrans: [],
            page: 1,
            currentList: "",
            totalList: "",
            currentDateList: "",
            totalDateList: "",
            period: [
                "thisWeek",
                "Today",
                "lastWeek",
                "lastMonth",
            ],
            selectedPeriod: "",
            token: localStorage.getItem("token"),
            error: "",
            startDate: "",
            endDate: "",
            transactionLists : true,
            dateTransaction : false,
            empty: "",
            currentPage:1,
            pageSize:20,
            searchLength: "",
            totalPages: "",
        }
    },

    mounted() {
        this.getTransactions();
    },
    computed: {
       
        filterName() {
            const query = this.searchQuery.toLowerCase()
            if(this.searchQuery) {
               return this.transactions.filter((theOrder) => {  
                     return Object.values(theOrder).some((word) => String(word).toLowerCase().includes(query))
                })
            }  else {
                return this.transactions.filter((row, index) => {
                let start = (this.currentPage -1)*this.pageSize;
                let end = this.currentPage*this.pageSize;
                let totalPages = this.transactions.length / this.pageSize
                this.totalPages = Math.round(totalPages)
                if(index >= start && index < end) return true;
                })
            }
            
        },

        filterNameSearch() {
            const query = this.searchQuery.toLowerCase()
            if(this.searchQuery) {
               return this.dateTrans.filter((theOrder) => {
                     return Object.values(theOrder).some((word) => String(word).toLowerCase().includes(query))
                })
            }  else {
                return this.dateTrans.filter((row, index) => {
                let start = (this.currentPage -1)*this.pageSize;
                let end = this.currentPage*this.pageSize;
                if(index >= start && index < end) return true;
                })
                // return this.orders
            }
            
        },

    },

    methods: {
        print() {
            window.print();
        },
        goBack() {
           this.$router.go(-1)
        },
        toggleList(trans) {
            trans.showItem = !trans.showItem
        },
        selectedTime(event) {
            this.selectedPeriod = event.target.value
            this.getTransactions()
        },
        next() {
            if((this.currentPage*this.pageSize) < this.transactions.length) this.currentPage++;
        },

        prev() {
            if(this.currentPage > 1) this.currentPage--
        },

        nextSearch() {
            this.page++
            this.getDateTransactions()
        },

        prevSearch() {
            this.page--
            this.getDateTransactions()            
        },

        moment(date) {
            return moment(date);
        },

         getTransactions() {
            let userId = localStorage.getItem("userId");
            axios({
              method: 'GET',
              url: `${url}/v1/web/transactions/${userId}`,
              headers: {
                  'Content-type': 'application/json',
                    authorization: `Bearer ${this.token}`,
                  'cg-key':  '7C99A10492E73F0A6B8F64029386A24DE7FAA2FC5EBFE8948242F423CADA3'
              },
          })
          .then((res) =>{
              this.transactions = res.data.data.results;
              this.currentList = this.transactions.length;
          })
          .catch((err) =>{
                this.error = err.response.data.message

          })
        },


        getDateTransactions() {
            axios({
              method: 'GET',
              url: `${url}/v1/web/transactions/${this.userId}&startDate=${this.startDate}&endDate=${this.endDate}`,
              headers: {
                  'Content-type': 'application/json',
                    authorization: `Bearer ${this.token}`,
                  'cg-key':  '7C99A10492E73F0A6B8F64029386A24DE7FAA2FC5EBFE8948242F423CADA3'
              }
          })
          .then((res) => {
              
              this.dateTrans = res.data.data.results;
              this.currentDateList = this.dateTrans.length;
              if(this.currentDateList <= 0 ) {
                  this.empty = "No Record"
              }
              console.log(this.currentDateList);
              this.totalDateList = res.data.data.totalResults;
          })
          .catch((err) => {
              this.error = err.response.data.message
          })
        },

        dateSearch() {
            this.transactionLists = false;
            this.dateTransaction = true
            this.getDateTransactions();
        }
    }
}
</script>